import BeeTable from './table.vue'

BeeTable.install = (Vue) => {
  Vue.component(BeeTable.name, BeeTable)
}

export default BeeTable



// WEBPACK FOOTER //
// ./src/components/table/index.js